import React from 'react';
import { Skeleton } from '@mui/material';
import { Grid, Card, Box } from '@mui/material';

export const SkeletonLoader = () => {
  return (
    <div className="flex w-full flex-col gap-1">
      <div className="flex items-center justify-center gap-2 w-full">
        <Skeleton variant="circular" width={60} height={60} />
        <div className="w-full">
          <Skeleton variant="rectangular" className="mb-3 mt-7 rounded-sm" width={200} height={50} />
          <Skeleton variant="rectangular" width={150} height={20} className="mb-2 rounded-sm" />
        </div>
      </div>
      <Skeleton variant="rectangular" height={160} className="rounded-md mb-7" />
    </div>
  );
};

export const DemographicsSkeleton = () => (
  <div className="flex w-full flex-col gap-1">
    <div className="flex items-center justify-center gap-2 w-full">
      <Skeleton variant="circular" width={48} height={48} />
      <div className="w-full">
        <Skeleton variant="text" width="80%" height={30} />
      </div>
    </div>
    <div className="bg-slate-100 flex-grow h-[200px] p-2 rounded-lg">
      <Skeleton variant="text" width="40%" height={25} className="mb-2" />
      <Skeleton variant="rectangular" width="100%" height={24} className="mb-2 rounded-full" />
      <div className="flex justify-center gap-4 mt-2 mb-4">
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className="flex items-center gap-2">
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton variant="text" width={40} height={16} />
          </div>
        ))}
      </div>
      <Skeleton variant="text" width="40%" height={25} className="mb-2" />
      <Skeleton variant="rectangular" width="100%" height={24} className="mb-2 rounded-full" />
      <div className="flex justify-center gap-4 mt-2">
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className="flex items-center gap-2">
            <Skeleton variant="circular" width={16} height={16} />
            <Skeleton variant="text" width={40} height={16} />
          </div>
        ))}
      </div>
    </div>
  </div>
);
export const InteractionsSkeleton = () => (
  <div className="flex w-full flex-col gap-1">
    <div className="flex items-center justify-center gap-2 w-full">
      <Skeleton variant="circular" width={48} height={48} />
      <div className="w-full">
        <div className="w-full flex space-x-1 mb-2">
          <Skeleton variant="rectangular" width="50%" height={40} className="rounded-md" />
          <Skeleton variant="rectangular" width="50%" height={40} className="rounded-md" />
        </div>
        <Skeleton variant="text" width="60%" height={25} />
      </div>
    </div>
    <div className="bg-slate-100 flex-grow h-[184px] p-2 rounded-lg">
      {[1, 2, 3, 4].map((item) => (
        <div className="mt-2" key={item}>
          <div className="flex gap-1 items-center">
            <Skeleton variant="circular" width={16} height={16} />
            <div className="flex items-center gap-2">
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="rectangular" width={50} height={24} className="rounded-md" />
              <Skeleton variant="rectangular" width={50} height={24} className="rounded-md" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Loading Skeleton Components
export const StoresLoadingSkeleton = () => {
  return (
    <Grid container spacing={2}>
      {[1, 2, 3].map((item) => (
        <Grid key={item} xs={12} item>
          <Card sx={{ padding: 2, opacity: 0.7 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ height: 30, width: '60%', bgcolor: '#e0e0e0', borderRadius: 1 }} />
              <Box sx={{ height: 20, width: '100%', bgcolor: '#e0e0e0', borderRadius: 1 }} />
              <Box sx={{ height: 20, width: '80%', bgcolor: '#e0e0e0', borderRadius: 1 }} />
              <Box sx={{ height: 20, width: '90%', bgcolor: '#e0e0e0', borderRadius: 1 }} />
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export const FootfallDataSkeleton = () => {
  return (
    <Box sx={{ width: '100%', height: '200px', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ height: '30px', width: '80%', bgcolor: '#e0e0e0', borderRadius: 1 }} />
      <Box sx={{ height: '150px', width: '100%', bgcolor: '#e0e0e0', borderRadius: 1 }} />
    </Box>
  );
};

export const EvidenceImagesSkeleton = () => {
  return (
    <Box sx={{ width: '100%', px: 4 }}>
      <Grid container spacing={1} sx={{ flexWrap: 'nowrap' }}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={3} key={item} sx={{ minWidth: '150px', maxWidth: '200px' }}>
            <Box
              sx={{
                height: '220px',
                width: '100%',
                bgcolor: '#e0e0e0',
                borderRadius: 1,
                marginTop: '20px',
                animation: 'pulse 1.5s ease-in-out infinite',
                '@keyframes pulse': {
                  '0%, 100%': { opacity: 0.6 },
                  '50%': { opacity: 0.3 }
                }
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export const MapSkeleton = () => <Skeleton variant="rectangular" width={120} height={250} animation="wave" sx={{ borderRadius: 1 }} />;
